export const removeCurrentUserParam = (key: string, get: any, set: any) => {
  const currentUserSearchParameters = get().currentUserSearchParameters
  const results = currentUserSearchParameters.filter(
    (x) => Object.keys(x)[0] !== key
  )
  set({ currentUserSearchParameters: results })
}
